import { connect } from 'react-redux'
import { configureItemRenderer } from './helpers'
import './index.scss'

Attributes = ({ data }) ->

  Details = configureItemRenderer(data.type, data.viewType)

  <div style={{ flex: '1 1 auto', overflow: 'auto' }}>
    <Details data={data} />
  </div>

export default connect(
  ({ explore }) -> { data: explore.currentItem }
)(Attributes)
